import React from "react"
import autobind from "class-autobind"
import strings from "../../../../localization/strings"
import { IScheduleTemplate, ISchedulePatternTemplate, IJobDocument } from "../../../../models"
import { FloatingActionButton, SelectField, MenuItem } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import ScheduleTemplateTimeinfoDetail7DaysView from "./ScheduleTemplateTimeinfoDetail7DaysView"
import ScheduleTemplateTimeinfoDetailListView from "./ScheduleTemplateTimeinfoDetailListView"
import AddShiftsDialog from "../../../../components/schedule/add_shift/AddShiftsDialog"
import * as permissionHelper from "../../../../helpers/permissionHelper"
import AuthenticationStore from "../../../../stores/AuthenticationStore"
import CloneDayDialog from "../../../../components/schedule/common/CloneDayDialog"
import * as scheduleHelper from "../../../../helpers/scheduleHelper"
import * as timeHelper from "../../../../helpers/timeHelper"
import * as api from "../../../../api"

interface IProps {
  scheduleTemplate: IScheduleTemplate
  handleAddPatternTemplates(scheduleTemplate: IScheduleTemplate, newPatternTemplates: ISchedulePatternTemplate[], days: number[]): void
  handleDeletePatternTemplates(scheduleTemplate: IScheduleTemplate, selectedPatternTemplates: ISchedulePatternTemplate[]): void
  handleUpdatePatternTemplateQty(scheduleTemplate: IScheduleTemplate, newPatternTemplate: ISchedulePatternTemplate, quantity: number): void
  handleClonePatternTemplates(scheduleTemplate: IScheduleTemplate, clonePatternTemplates: ISchedulePatternTemplate[]): void
  handleUpdateUniquePatternTemplate(scheduleTemplate: IScheduleTemplate, uniquePatternTemplate: ISchedulePatternTemplate): void
}
interface IState {
  loadingJob: boolean
  viewType: ETimeInfoDetailViewType
  selectedDay: number
  openAddShiftDialog: boolean
  confirmDialogPayload: any
  openCloneDialog: boolean
  cloneDay: number
  candidateClonePatternTemplates: ISchedulePatternTemplate[]
  scheduleJob: IJobDocument
}
enum ETimeInfoDetailViewType {
  listView = "LIST",
  sevenDayView = "7DAYS"
}


export default class ScheduleTemplateTimeInfoDetail extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      loadingJob: false,
      viewType: ETimeInfoDetailViewType.sevenDayView,
      selectedDay: -1,
      openAddShiftDialog: false,
      confirmDialogPayload: null,
      openCloneDialog: false,
      cloneDay: -1,
      candidateClonePatternTemplates: [],
      scheduleJob: null
    }
    autobind(this)
  }

  componentDidMount() {
    this.getJob(this.props.scheduleTemplate.JobId)
  }

  componentWillReceiveProps(nextProps: IProps) {
    this.props.scheduleTemplate.JobId !== nextProps.scheduleTemplate.JobId &&
      this.getJob(nextProps.scheduleTemplate.JobId)
  }

  getJob(jobId) {
    jobId ?
      this.setState({ loadingJob: true }, () =>
        api.getJob(jobId).then(res =>
          this.setState({ loadingJob: false, scheduleJob: res.data })
        )
      ) :
      this.setState({ loadingJob: false, scheduleJob: null })
  }

  handleChangeSelectedDay(selectedDay) {
    this.setState({ selectedDay })
  }

  handleDeletePatternTemplates(patternTemplates) {
    this.props.handleDeletePatternTemplates(this.props.scheduleTemplate, patternTemplates)
  }

  handleUpdatePatternTemplateQty(patternTemplate, quantity) {
    this.props.handleUpdatePatternTemplateQty(this.props.scheduleTemplate, patternTemplate, quantity)
  }

  handleUpdateUniquePatternTemplate(uniquePatternTemplate: ISchedulePatternTemplate) {
    this.props.handleUpdateUniquePatternTemplate(this.props.scheduleTemplate, uniquePatternTemplate)
  }

  handleOpenCloneDialog(candidateClonePatternTemplates, cloneDay) {
    this.setState({ candidateClonePatternTemplates, cloneDay })
  }

  render() {
    return (
      <div style={{ padding: 10, position: "relative" }} id="ScheduleTemplateTimeInfoDetail">
        {permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule) && this.state.selectedDay > -1 &&
          <FloatingActionButton data-intercom-target={"ScheduleTemplates-TimeInfoDetails-Btn-Add"} className="fixed-add" style={{ top: -30, right: 15, zIndex: 998 }} secondary={true} onTouchTap={() => this.setState({ openAddShiftDialog: true })}>
            <ContentAdd />
          </FloatingActionButton>
        }
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <SelectField
            data-intercom-target={"ScheduleTemplates-TimeInfoDetails-Select-ViewType"}
            floatingLabelText={strings.Seven_Day_List}
            value={this.state.viewType}
            onChange={(e, key, payload) =>
              this.setState({ viewType: payload })
            }
            style={{ width: 175 }}
          >
            <MenuItem value={ETimeInfoDetailViewType.listView} primaryText={strings.List_View} />
            <MenuItem value={ETimeInfoDetailViewType.sevenDayView} primaryText={strings.Seven_Day_View} />
          </SelectField>
        </div>
        <div>
          {this.state.viewType === ETimeInfoDetailViewType.listView ?
            <ScheduleTemplateTimeinfoDetailListView
              scheduleTemplate={this.props.scheduleTemplate}
              handleChangeSelectedDay={this.handleChangeSelectedDay}
              handleDeletePatternTemplates={this.handleDeletePatternTemplates}
              handleUpdatePatternTemplateQty={this.handleUpdatePatternTemplateQty}
              handleOpenCloneDialog={this.handleOpenCloneDialog}
              handleUpdateUniquePatternTemplate={this.handleUpdateUniquePatternTemplate}
            /> :
            <ScheduleTemplateTimeinfoDetail7DaysView
              scheduleTemplate={this.props.scheduleTemplate}
              handleChangeSelectedDay={this.handleChangeSelectedDay}
              handleDeletePatternTemplates={this.handleDeletePatternTemplates}
              handleUpdatePatternTemplateQty={this.handleUpdatePatternTemplateQty}
              handleOpenCloneDialog={this.handleOpenCloneDialog}
              handleUpdateUniquePatternTemplate={this.handleUpdateUniquePatternTemplate}
            />
          }
        </div>
        {this.state.openAddShiftDialog && !this.state.loadingJob &&
          <AddShiftsDialog
            isScheduleTemplate
            selectedDay={this.state.selectedDay}
            schedule={this.props.scheduleTemplate}
            scheduleJob={this.state.scheduleJob}
            handleClose={() => this.setState({ openAddShiftDialog: false })}
            handleAddPatternTemplates={(patternTemplates, days) => {
              this.setState({ openAddShiftDialog: false })
              this.props.handleAddPatternTemplates(this.props.scheduleTemplate, patternTemplates, days)
            }}
          />
        }
        {this.state.cloneDay > -1 &&
          <CloneDayDialog
            isScheduleTemplate
            scheduleStartDate={timeHelper.keepConvertUTCToLocal(this.props.scheduleTemplate.StartDate)}
            candidateCloneDay={this.state.cloneDay}
            dayLength={scheduleHelper.getDayLengthFromStartAndEndTime(this.props.scheduleTemplate.StartDate, this.props.scheduleTemplate.EndDate)}
            candidateClonePatternTemplates={this.state.candidateClonePatternTemplates}
            handleClose={() => this.setState({ cloneDay: -1, candidateClonePatternTemplates: [] })}
            handleSave={clonePatternTemplates => {
              this.props.handleClonePatternTemplates(this.props.scheduleTemplate, clonePatternTemplates)
              this.setState({ cloneDay: -1, candidateClonePatternTemplates: [] })
            }}
          />
        }
      </div>
    )
  }
}